<!-- 收费设置-->
<template>
  <div class="payment-wrap">
    <div class="box" v-for="(item, index) in paymentList" :key="index">
      <div class="tips-top">
        <div class="tips-text">
          <img :src="item.icon_url" alt="" class="icon-img">
          <span>{{item.title}}</span>
        </div>
        <a-switch :checked="item.status" @click="onChange(index)" />
      </div>
      <div class="lable"><i>*</i>商户号:</div>
      <a-input placeholder="请输入物业公司的商务号" v-model="item.merchant_no"/>
      <div class="text">请务必确保填写商户号跟物业公司相对应</div>
      <a-button type="primary" style="width: 100px;" @click="submit(index)">保存</a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment',
  data () {
    return {
      paymentList: [],
      property_id: ''
    };
  },
  created () {
    this.property_id = this.$route.query.id;
    this.getList(this.property_id);
  },
  methods: {
    getList (id) {
      this._get({
        url: `/property/${id}/charge`
      }).then(({data}) => {
        this.paymentList = data;
        this.paymentList.forEach(item => {
          item.status ? item.status = true : item.status = false;
        });
      });
    },
    onChange (index) {
      this.paymentList[index].status = !this.paymentList[index].status;
      this._post({
        url: `/property/${this.property_id}/charge/${this.paymentList[index].setting_id}/change`,
        params: { status: this.paymentList[index].status }
      }).then(res => {
        this.$message.success(res.msg);
      });
    },
    submit (index) {
      let obj = this.paymentList[index];
      if (!obj.merchant_no) return this.$message.error('请填写商务号');
      this._post({
        url: `/property/${this.property_id}/charge/${obj.setting_id}`,
        params: { merchant_no: obj.merchant_no, status: obj.status }
      }).then(res => {
        this.$message.success(res.msg);
      });
    }
  }
};

</script>

<style lang="less" scoped>
.payment-wrap{
  width: 100%;
  background-color: #fff;
  padding: 20px 20px 100px 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  .box{
    width: 31.9%;
    height: 300px;
    padding: 30px;
    border: 1px solid #666;
    border-radius: 10px;
    .tips-top{
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .icon-img{
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
    }
    .lable{
      margin-bottom: 10px;
      i{
        color: red;
        margin-right: 5px;
      }
    }
    .text{
      margin: 10px 0 30px 00px;
      font-size: 14px;
      color: #ccc;
    }
  }
  .box:nth-of-type(2) {
    margin: 0 20px 0;
  }
}
</style>
